/* sk-account.js — carries the SK account onto the cart (UAS 9.1 / 5.5, contract C-6).
 *
 * Sources, in precedence order:
 *   1. ?sk_account= / ?sk_a= on the URL — an explicit statement of intent, so it wins.
 *   2. the sk_account COOKIE on the parent domain (.stonekite-test.com), set by the platform
 *      shell. This only works because the store is served from a sibling hostname rather than
 *      *.myshopify.com, and it is what makes the binding work on EVERY entry path — bookmark,
 *      search result, Discord link, tab reopened days later — not just links we generated.
 *   3. sessionStorage, so it survives navigation within a tab.
 *
 * Whichever wins is written to the CART as attributes[account_id], which Shopify delivers as
 * note_attributes on the order webhook — the field core/commerce/shopify.mjs already reads.
 *
 * Not HttpOnly by design: storefront JS must read it. Safe because an account_id authenticates
 * nothing on its own, and the cart attribute it feeds was already client-supplied and forgeable
 * on a tier without Multipass (9.1). Source of truth:
 * sk-launch-program/workstreams/shopify/store/theme/assets/sk-account.js
 */
(function () {
  var KEY = 'sk-account-id';
  var ATTR = 'account_id';
  function valid(id) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id || '');
  }
  function fromUrl() {
    try {
      var p = new URLSearchParams(location.search);
      return p.get('sk_account') || p.get('sk_a') || '';
    } catch (e) {
      return '';
    }
  }
  function fromCookie() {
    try {
      var m = ('; ' + document.cookie).match(/; *sk_account=([^;]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }
  function remembered() {
    try {
      return sessionStorage.getItem(KEY) || '';
    } catch (e) {
      return '';
    }
  }
  function remember(id) {
    try {
      sessionStorage.setItem(KEY, id);
    } catch (e) {}
  }
  function applyToCart(id) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var attrs = {};
    attrs[ATTR] = id;
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).catch(function () {});
  }
  function stampForms(id) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var e = forms[i].querySelector('input[name="attributes[' + ATTR + ']"]');
      if (e) {
        e.value = id;
        continue;
      }
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + ATTR + ']';
      input.value = id;
      forms[i].appendChild(input);
    }
  }
  var incoming = fromUrl();
  var cookied = fromCookie();
  var id = valid(incoming) ? incoming : valid(cookied) ? cookied : remembered();
  if (!valid(id)) return;
  if (valid(incoming)) remember(incoming);
  else if (!remembered()) remember(id);
  applyToCart(id);
  stampForms(id);
  document.documentElement.setAttribute('data-sk-account', 'bound');
  document.documentElement.setAttribute(
    'data-sk-account-src',
    valid(incoming) ? 'url' : valid(cookied) ? 'cookie' : 'session',
  );
  document.addEventListener('shopify:section:load', function () {
    stampForms(id);
  });
})();
